/* eslint-disable eqeqeq */
import axios from "axios";
import { toast } from "react-toastify";
import { CONTENT_TYPE_KEY, AUTHORIZATION_KEY } from "../config/auth";
import { getIdToken, logOut } from "./auth";

export const apiRequest = ({
  method = "",
  url = "",
  data = null,
  contentType = "",
  isAuthorized = false,
  fileDownload = false,
  blobHeader = false,
}) => {
  let headers = {
    // "Cache-Control": "no-cache",
    // Pragma: "no-cache",
  };
  let validCall = true;
  if (isAuthorized) {
    const accessToken = getIdToken();
    if (accessToken) {
      headers[CONTENT_TYPE_KEY] = contentType;
      headers[AUTHORIZATION_KEY] = accessToken;
    } else {
      validCall = false;
    }
  }

  if (validCall) {
    if (blobHeader) {
      headers["x-ms-blob-type"] = "BlockBlob";
      headers[CONTENT_TYPE_KEY] = contentType;
    }
    method = method.toLowerCase();

    let params = {
      params: data,
      headers,
    };
    /**
     * need to send responseType = 'blob' while downloading the file
     * otherwise the downloaded file will be corrupted
     */
    if (fileDownload) {
      params.responseType = "blob";
      return axios[method](url, params)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          throw err;
        });
    }

    if (method === "get") {
      return axios[method](url, {
        params: data,
        headers,
      })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err && err.response && err.response.status == "401") {
            if (err.response?.data?.error === "Token Expired") {
              toast.error("Session Expired!");
              logOut();
              return null;
            } else {
              toast.error("Not Authorized!");
            }

            // if (window.location.pathname !== "/home") {
            //   window.location.href = "/home";
            // }
          }
          throw err;
        });
    } else if (method === "delete") {
      return axios[method](url, {
        data: data,
        headers,
      })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err && err.response && err.response.status == "401") {
            if (err.response?.data?.error === "Token Expired") {
              toast.error("Session Expired!");
              logOut();
              return null;
            } else {
              toast.error("Not Authorized!");
            }

            // if (window.location.pathname !== "/home") {
            //   window.location.href = "/home";
            // }
          }
          throw err;
        });
    } else {
      return axios[method](url, data, {
        headers,
      })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err && err.response && err.response.status == "401") {
            if (err.response?.data?.error === "Token Expired") {
              toast.error("Session Expired!");
              logOut();
              return null;
            } else {
              toast.error("Not Authorized!");
            }

            // if (window.location.pathname !== "/home") {
            //   window.location.href = "/home";
            // }
          }
          throw err;
        });
    }
  } else {
    toast.error("Session Expired!");
    logOut();
  }
};
